import Nullstack from 'nullstack';
export default function IconCheese({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-cheese",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M4.519 20.008l16.481 -.008v-3.5a2 2 0 1 1 0 -4v-3.5h-16.722"
  }), "   ", Nullstack.element("path", {
    d: "M21 9l-9.385 -4.992c-2.512 .12 -4.758 1.42 -6.327 3.425c-1.423 1.82 -2.288 4.221 -2.288 6.854c0 2.117 .56 4.085 1.519 5.721"
  }), "   ", Nullstack.element("path", {
    d: "M15 13v.01"
  }), "   ", Nullstack.element("path", {
    d: "M8 13v.01"
  }), "   ", Nullstack.element("path", {
    d: "M11 16v.01"
  }), " ");
}